module.exports = __webpack_public_path__ + "img/logo-camtil-branco.01683374.png";